// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header__container-c2ce73 {
  height: var(--header-height);
  padding: 0 22px 0 34px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--base-20);
}

.Header__right-block-cebe59 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.Header__icon-cb1710 {
  margin-inline-start: 15px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/ArticlePreview/Header/styles.m.css"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,uCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":[".container {\n  height: var(--header-height);\n  padding: 0 22px 0 34px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid var(--base-20);\n}\n\n.right-block {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon {\n  margin-inline-start: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Header__container-c2ce73`,
	"right-block": `Header__right-block-cebe59`,
	"rightBlock": `Header__right-block-cebe59`,
	"icon": `Header__icon-cb1710`
};
module.exports = ___CSS_LOADER_EXPORT___;
